import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule} from "@angular/common/http";
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AuthInterceptor} from "./interceptors/auth.interceptor";
import {AuthenticationService, AuthenticationServiceFactory} from "./services/authentication.service";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {environment} from "../environments/environment";
import {CountUpModule} from "ngx-countup";
import {GoogleLoginProvider} from "@abacritt/angularx-social-login";
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";
import Bugsnag from "@bugsnag/js";
import {BugsnagErrorHandler} from "@bugsnag/plugin-angular";
import {IConfig, NgxMaskModule} from "ngx-mask";
import {PixelModule} from "ngx-multi-pixel";
import {NgxStripeModule} from "ngx-stripe";
import {Loader} from "@googlemaps/js-api-loader";
import {CookieService} from "ngx-cookie-service";
import {ToastrModule} from "ngx-toastr";
import {provideClarity} from "ngx-clarity";

Bugsnag.start('398d010da93acc70aba21dd598abec1e');

export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

export const options: Partial<null | IConfig> | (() => Partial<IConfig>) = null;


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    HttpClientJsonpModule,
    HttpClientModule,
    CountUpModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxMaskModule.forRoot(),
    PixelModule.forRoot({
      enabled: false,
      pixelId: ['1163840941256698']
    }),
    NgxStripeModule.forRoot(environment.stripePublishableKey),
    ToastrModule.forRoot()
  ],
  providers: [
    CookieService,
    {
      provide: ErrorHandler,
      useFactory: errorHandlerFactory
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [{
          id: GoogleLoginProvider.PROVIDER_ID,
          provider: new GoogleLoginProvider(environment.googleOAuthClientId)
        }
        ]
      }
    },
    {
      provide: APP_INITIALIZER,
      useFactory: AuthenticationServiceFactory,
      deps: [AuthenticationService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: environment.googleAPIKey,
        libraries: ['places', 'maps'],
        language: 'en',
      })
    },
    provideClarity({
      enabled: true,
      projectId: 'ojp65wh9vm',
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
